import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';

const ListingTable = (props) => {
  const columns = [
    { attribute: 'name' },
    { attribute: 'group' },
    { attribute: 'priority' },
    { attribute: 'maximum_capacity', label: 'capacity' },
    { attribute: 'nb_bedrooms', label: 'bedrooms' },
    { attribute: 'nb_bathrooms', label: 'bathrooms' },
    { attribute: 'base_price_per_night', label: 'Base price/night', value: (o) => Math.round(o.base_price_per_night) + ' €' },
    { attribute: 'total_price_per_night_per_person', label: 'Total price/person/night', value: (o) => Math.round(o.total_price_per_night_per_person) + ' €' },
    { attribute: 'total_price', label: 'Total', value: (o) => Math.round(o.total_price) + ' €' },
  ];
  const valueForPriority = {
    very_high: 1,
    high: 2,
    normal: 3,
    low: 4,
    very_low: 5,
  };
  const getSortedAvailabilities = () => {
    let availabilities = props.availabilities.slice();
    if (props.relatedObject && props.relatedObject.property) {
      const originalPropertyId = props.relatedObject.property.id;
      availabilities = availabilities.filter(a => a.id !== originalPropertyId);
    }
    if (!props.sort) return availabilities;
    const [attr, order] = props.sort;
    availabilities.sort((a, b) => {
      const valueA = attr === 'priority' ? valueForPriority[a[attr]] : a[attr];
      const valueB = attr === 'priority' ? valueForPriority[b[attr]] : b[attr];
      if (order === 'asc') return ['name', 'group'].includes(attr) ? valueA.localeCompare(valueB) : valueA - valueB;
      return ['name', 'group'].includes(attr) ? valueB.localeCompare(valueA) : valueB - valueA;
    });
    return availabilities;
  };
  const hasSelectedItems = Object.keys(props.selectedItems).filter(id => props.selectedItems[id]).length > 0;
  const showBatchActions = !props.location.query.action || props.location.query.action !== 'make_offer';

  return (
    <div className="table-responsive no-padding">
      <div className="box-header">
        {
          showBatchActions
            ? <DropdownButton title="Batch actions" disabled={ !hasSelectedItems } pullLeft bsSize="small" id="Menu batch actions">
                <MenuItem onClick={ props.onClickSuggest }>Make a proposal</MenuItem>
              </DropdownButton>
            : null
        }
      </div>
      <table className="table table-hover table-striped table-bordered table-responsive">
        <thead>
          <tr>
            {
              showBatchActions
                ? <th className="checkbox-batch-action">
                    <input type="checkbox" onClick={ props.onClickCheckboxAll } checked={ props.allCheckboxesChecked } />
                  </th>
                : null
            }
            {
              columns.map(renderHeader.bind(null, props))
            }
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            getSortedAvailabilities().map((availability, i) => {
              return (
                <tr key={i}>
                  {
                    showBatchActions
                      ? <td className="checkbox-batch-action">
                          <input type="checkbox" onClick={ props.onSelectItem.bind(null, availability.id) } checked={ !!props.selectedItems[availability.id] } />
                        </td>
                      : null
                  }
                  {
                    columns.map((column, j) => {
                      const value = column.value
                        ? column.value(availability)
                        : availability[column.attribute];
                      return <td key={j}>{ value }</td>;
                    })
                  }
                  <DropdownButton title="Actions" pullRight bsSize="small" id="Menu batch actions">
                    <MenuItem onClick={ props.onClickOffer.bind(null, availability.id) }>Make an offer</MenuItem>
                  </DropdownButton>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </div>
  );
};

function renderHeader(props, column, i) {
  const handleSort = (currentOrder, attribute) => {
    const order = currentOrder === 'asc' ? 'desc' : 'asc';
    const param = `${attribute}__${order}`;
    props.onSort(param);
  };
  const attribute = column.attribute;
  const label = column.label ? column.label : column.attribute;
  const sortingClass = props.sort && props.sort[0] === attribute
    ? props.sort[1]
    : '';
  let sortingIconClass = 'fas fa-arrows-v';
  if (sortingClass === 'asc') sortingIconClass = 'fas fa-long-arrow-up';
  if (sortingClass === 'desc') sortingIconClass = 'fas fa-long-arrow-down';
  return (
    <th key={i} className={ `sorting ${sortingClass}`} onClick={ handleSort.bind(null, sortingClass, attribute) }>
      { label } <i className={ sortingIconClass }></i>
    </th>
  );
}

export default ListingTable;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/components/ListingTable.jsx